import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "company-info relative"
};
const _hoisted_2 = {
  class: "form-info whitespace-pre-wrap break-all"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 2
};
const _hoisted_6 = {
  key: 0,
  class: "footer-info mt-4"
};
const _hoisted_7 = {
  class: "info"
};
const _hoisted_8 = {
  class: "flex justify-between"
};
const _hoisted_9 = {
  class: "doc flex mt-2"
};
const _hoisted_10 = ["title"];
const _hoisted_11 = {
  class: "icon-box"
};
const _hoisted_12 = {
  class: "ml-1 flex-1 overflow-hidden"
};
const _hoisted_13 = {
  class: "truncate title"
};
const _hoisted_14 = {
  class: "ext truncate"
};
import { ref, computed } from 'vue';
import { ArrowDownBold } from '@element-plus/icons-vue';
import { getModelName } from '@views/main/config';
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyInfo',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const isFold = ref(true);
    const info = computed(() => {
      try {
        return JSON.parse(props.content.tips);
      } catch {
        return {
          keywords: [],
          websiteInfo: '',
          productOrService: '',
          files: []
        };
      }
    });
    const modelHtml = computed(() => {
      const arr = [];
      info.value.selectionModel.forEach(x => {
        const modelItem = getModelName(x);
        if (modelItem) arr.push(`【${modelItem.label}】`);
      });
      return arr.join('、') || '';
    });
    const showFiles = computed(() => {
      if (isFold.value) {
        return info.value.files.slice(0, 4);
      }
      return info.value.files;
    });
    function handleExt(ext) {
      if (!ext) return '--';
      const str = ext.split('/').pop();
      return str.toLocaleUpperCase();
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_i_home_doc = _resolveComponent("i-home-doc");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, "背景：我公司的产品或服务是【" + _toDisplayString(info.value.productOrService) + "】", 1), _createElementVNode("p", null, "AI提示词：" + _toDisplayString(info.value.keywords.map(x => `【${x}】`).join('、')), 1), info.value.websiteInfo ? (_openBlock(), _createElementBlock("p", _hoisted_3, "官网信息：" + _toDisplayString(info.value.websiteInfo), 1)) : _createCommentVNode("", true), info.value.brandWords ? (_openBlock(), _createElementBlock("p", _hoisted_4, "品牌词：" + _toDisplayString(info.value.brandWords.map(x => `【${x}】`).join('、')), 1)) : _createCommentVNode("", true), info.value.selectionModel ? (_openBlock(), _createElementBlock("p", _hoisted_5, "选择模型：" + _toDisplayString(modelHtml.value), 1)) : _createCommentVNode("", true), _cache[1] || (_cache[1] = _createElementVNode("p", null, "任务目标：执行AI提示词GEO优化策略，帮助品牌内容在用户使用生成式AI应用时（如豆包或DeepSeek），获得更好的展示效果和更高的可见性。", -1))]), info.value.files?.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "label mr-2"
      }, "企业资料：", -1)), info.value.files.length > 4 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fold-btn",
        onClick: _cache[0] || (_cache[0] = $event => isFold.value = !isFold.value)
      }, [_createElementVNode("span", null, _toDisplayString(isFold.value ? '展开' : '收起'), 1), _createVNode(_component_el_icon, {
        class: _normalizeClass(["text-[#86909C] cursor-pointer", {
          fold: !isFold.value
        }])
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowDownBold))]),
        _: 1
      }, 8, ["class"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showFiles.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item,
          class: "file-item overflow-hidden",
          title: `文件-${item.fileName}`
        }, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_i_home_doc, {
          class: "w-8 h-8"
        })]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.fileName), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(handleExt(item.fileFormat)), 1)])], 8, _hoisted_10);
      }), 128))])])])) : _createCommentVNode("", true)]);
    };
  }
});